import ProductSearchReducer from "./ProductSearchReducer";
import MerchantProductSearchReducer from "src/reducers/MerchantProductSearchReducer";
import GeneralProductSearchReducer from "src/reducers/GeneralProductSearchReducer";
import ProgramMetadataReducer from "src/reducers/ProgramMetadataReducer";
import WeblabReducer from "./WeblabReducer";
import SelectedProductReducer from "src/reducers/SelectedProductReducer";
import QueryProductReducer from "src/reducers/QueryProductReducer";
import ProgramFeesQueryReducer from "src/reducers/ProgramFeesQueryReducer";
import CurrentCountryCodeQueryReducer from "src/reducers/CurrentCountryCodeQueryReducer";
import IsSelectNewReducer from "src/reducers/IsSelectNewReducer";
import UserPreferenceReducer from "src/reducers/UserPreferenceReducer";
import RecommendationReducer from "src/reducers/RecommendationReducer";
import BulkProductReducer from "src/reducers/BulkProductReducer";
import BulkProductSearchReducer from "src/reducers/BulkProductSearchReducer";
import BulkReportQueryReducer from "src/reducers/BulkReportQueryReducer";
import FeeCatReducer from "src/reducers/FeeCatReducer";

function createReducer() {
    let reducers = {
        feeCatRes: FeeCatReducer,
        productRes: ProductSearchReducer,
        merchantProductRes: MerchantProductSearchReducer,
        generalProductRes: GeneralProductSearchReducer,
        programMetadataRes: ProgramMetadataReducer,
        recommendationRes: RecommendationReducer,
        programFeesRes: ProgramFeesQueryReducer,
        selectedProductRes: SelectedProductReducer,
        queryProductRes: QueryProductReducer,
        weblabTreatmentsRes: WeblabReducer,
        currentCountryCodeRes: CurrentCountryCodeQueryReducer,
        userPreferenceRes: UserPreferenceReducer,
        isSelectNewRes: IsSelectNewReducer,
        bulkProductsRes: BulkProductReducer,
        bulkProductSearchRes: BulkProductSearchReducer,
        bulkReportRes: BulkReportQueryReducer,
    };

    return reducers;
}

export default createReducer();
